<template>
  <div class="data_up">
    <div class="top-area">
      <p class="top-title">选择地区</p>
      <el-select v-model="areaIds[0]" clearable @change="remoteMethod($event,1)" style="width:160px;padding-left:10px;" placeholder="省">
        <el-option v-for="x in province" :key="x.id" :label="x.name" :value="x.id"></el-option>
      </el-select>
      <el-select v-model="areaIds[1]" clearable @change="remoteMethod($event,2)" style="width:160px;padding-left:10px;" placeholder="市">
        <el-option v-for="x in city" :key="x.id" :label="x.name" :value="x.id"></el-option>
      </el-select>
      <el-select v-model="areaIds[2]" clearable @change="remoteMethod($event,3)" style="width:160px;padding-left:10px;" placeholder="县">
        <el-option v-for="x in county" :key="x.id" :label="x.name" :value="x.id"></el-option>
      </el-select>
      <el-select v-model="areaIds[3]" clearable @change="remoteMethod($event,4)" style="width:160px;padding-left:10px;" placeholder="镇">
        <el-option v-for="x in town" :key="x.id" :label="x.name" :value="x.id"></el-option>
      </el-select>
      <el-select v-model="areaIds[4]" clearable @change="remoteMethod($event,5)" style="width:160px;padding-left:10px;" placeholder="村">
        <el-option v-for="x in village" :key="x.id" :label="x.name" :value="x.id"></el-option>
      </el-select>
    </div>
    <div class="center">
      <el-radio v-model="radio" label="1">测试数据</el-radio>
      <el-radio v-model="radio" label="2">真实数据</el-radio>
    </div>
    <el-form :model="ruleForm" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <div v-for="(x,i) in formLabels" :key="i">
        <el-col :span="24">
          <h4>{{x.title}}</h4>
        </el-col>
        <el-col :span="4" v-for="x2 in x.labels" :key="x2.key">
          <el-form-item :label="x2.label+':'">
            <el-input type="text" size="mini" v-model.number="ruleForm[x2.key]"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <el-col :span="24" class="center">
        <el-form-item>
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [ mixins ],
  data: function () {
    return {
      radio: 0,
      id: '',

      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      areaIds: [],

      ruleForm: {
        haveJob: '', //有工作
        noJobNoWish: '', //无工作，无就业意愿
        noJobHaveWish: '', //无工作，有就业意愿

        ageRange18To30: '', //18到30
        ageRange31To40: '', //31到40
        ageRange41To50: '', //41到50
        ageRange51To60: '', //51到60
        educationHighSchool: '', //高中以下
        educationSecondary: '', //中专
        educationUniversity3: '', //专科
        educationUniversity4: '', //本科
        educationMaster: '', //硕士及以上

        jobOranization: '', //单位就业
        jobFlexible: '', //灵活就业
        jobWorkshop: '', //扶贫车间
        jobPublicWelfare: '', //公益岗位
        jobPioneer: '', //创业
        jobOther: '', //其它

        // jobGroupPoor: '', //贫困人员
        // jobGroupUniversity: '', //高校毕业生
        // jobGroupRetireSoldier: '', //退役军人
        // jobGroupLostJob: '', //其它社会失业人员
        hiStudentHasJob: '',
        hiStudentNoJobNoWish: '',
        hiStudentNoJobHaveWish: '',
        soldierHasJob: '',
        soldierNoJobNoWish: '',
        soldierNoJobHaveWish: '',
        disableHasJob: '',
        disableNoJobNoWish: '',
        disableNoJobHaveWish: '',
        fishManHasJob: '',
        fishManNoJobNoWish: '',
        fishManNoJobHaveWish: '',
        lostJobHasJob: '',
        lostJobNoJobNoWish: '',
        lostJobNoJobHaveWish: '',

        jobAreaCounty: '', //县内
        jobAreaProvinceIn: '', //县外省内
        jobAreaZhu3: '', //珠三角
        jobAreaLong3: '', //长三角
        jobAreaJJArea: '', //京津冀
        jobAreaOutside: '', //境外
        jobAreaOther: '', //其它

        lostSalary: '', //欠薪人数
        dealLostSalary: '', //已处理
        notDealLostSalary: '', //未处理
        needPersons: '', //招聘人数
        workPersons: '', //已招聘人数
        emptyWorkPersons: '', //空岗人数
      },
      formLabels: [
        { title: '贫困劳动力', labels: [
          { label: '已就业人员', key: 'haveJob' },
          { label: '无就业意愿', key: 'noJobNoWish' },
          { label: '有就业意向', key: 'noJobHaveWish' },
        ] },
        { title: '个人年龄文化分析 - 年龄', labels: [
          { label: '18-30', key: 'ageRange18To30' },
          { label: '31-40', key: 'ageRange31To40' },
          { label: '41-50', key: 'ageRange41To50' },
          { label: '51-60', key: 'ageRange51To60' },
        ] },
        { title: '个人年龄文化分析 - 文化', labels: [
          { label: '高中以下', key: 'educationHighSchool' },
          { label: '中专', key: 'educationSecondary' },
          { label: '专科', key: 'educationUniversity3' },
          { label: '本科', key: 'educationUniversity4' },
          { label: '硕士及以上', key: 'educationMaster' },
        ] },
        { title: '个人就业方式分析', labels: [
          { label: '单位就业', key: 'jobOranization' },
          { label: '灵活就业', key: 'jobFlexible' },
          { label: '扶贫车间', key: 'jobWorkshop' },
          { label: '公益岗位', key: 'jobPublicWelfare' },
          { label: '自由职业', key: 'jobPioneer' },
          { label: '其它职业', key: 'jobOther' },
        ] },
        { title: '个人就业群体分布 - 高校毕业生', labels: [
          { label: '已就业人员', key: 'hiStudentHasJob' },
          { label: '无就业意愿', key: 'hiStudentNoJobNoWish' },
          { label: '有就业意向', key: 'hiStudentNoJobHaveWish' },
        ] },
        { title: '个人就业群体分布 - 退役军人', labels: [
          { label: '已就业人员', key: 'soldierHasJob' },
          { label: '无就业意愿', key: 'soldierNoJobNoWish' },
          { label: '有就业意向', key: 'soldierNoJobHaveWish' },
        ] },
        { title: '个人就业群体分布 - 残疾人', labels: [
          { label: '已就业人员', key: 'disableHasJob' },
          { label: '无就业意愿', key: 'disableNoJobNoWish' },
          { label: '有就业意向', key: 'disableNoJobHaveWish' },
        ] },
        { title: '个人就业群体分布 - 退捕渔民', labels: [
          { label: '已就业人员', key: 'fishManHasJob' },
          { label: '无就业意愿', key: 'fishManNoJobNoWish' },
          { label: '有就业意向', key: 'fishManNoJobHaveWish' },
        ] },
        { title: '个人就业群体分布 - 其它失业人员', labels: [
          { label: '已就业人员', key: 'lostJobHasJob' },
          { label: '无就业意愿', key: 'lostJobNoJobNoWish' },
          { label: '有就业意向', key: 'lostJobNoJobHaveWish' },
        ] },
        // { title: '个人就业群体分布', labels: [
        //   //高校毕业生
        //   { label: '高校毕业生已就业人员', key: 'hiStudentHasJob' },
        //   { label: '高校毕业生无就业意愿', key: 'hiStudentNoJobNoWish' },
        //   { label: '高校毕业生有就业意向', key: 'hiStudentNoJobHaveWish' },
        //   //退役军人
        //   { label: '退役军人已就业人员', key: 'soldierHasJob' },
        //   { label: '退役军人无就业意愿', key: 'soldierNoJobNoWish' },
        //   { label: '退役军人有就业意向', key: 'soldierNoJobHaveWish' },
        //   //残疾人
        //   { label: '残疾人已就业人员', key: 'disableHasJob' },
        //   { label: '残疾人无就业意愿', key: 'disableNoJobNoWish' },
        //   { label: '残疾人有就业意向', key: 'disableNoJobHaveWish' },
        //   //退捕渔民
        //   { label: '退捕渔民已就业人员', key: 'fishManHasJob' },
        //   { label: '退捕渔民无就业意愿', key: 'fishManNoJobNoWish' },
        //   { label: '退捕渔民有就业意向', key: 'fishManNoJobHaveWish' },
        //   //其它失业人员
        //   { label: '其它失业人员已就业人员', key: 'lostJobHasJob' },
        //   { label: '其它失业人员无就业意愿', key: 'lostJobNoJobNoWish' },
        //   { label: '其它失业人员有就业意向', key: 'lostJobNoJobHaveWish' },
        // ] },
        { title: '个人就业区域分析', labels: [
          { label: '县内', key: 'jobAreaCounty' },
          { label: '县外省内', key: 'jobAreaProvinceIn' },
          { label: '珠三角', key: 'jobAreaZhu3' },
          { label: '长三角', key: 'jobAreaLong3' },
          { label: '京津冀', key: 'jobAreaJJArea' },
          { label: '境外', key: 'jobAreaOutside' },
          { label: '其它', key: 'jobAreaOther' },
        ] },
        { title: '区域就业招聘分析', labels: [
          { label: '欠薪人数', key: 'lostSalary' },
          { label: '已处理', key: 'dealLostSalary' },
          { label: '未处理', key: 'notDealLostSalary' },
          { label: '招聘人数', key: 'needPersons' },
          { label: '已招聘人数', key: 'workPersons' },
          { label: '空岗人数', key: 'emptyWorkPersons' },
        ] },
      ]
    }
  },
  methods: {
    submitForm() {
      if (this.areaIds[0].length> 0 ) {
        let place = this.areaIds.filter(x => x)
        this.ruleForm.id = place[place.length - 1]
        this.ruleForm.fix = this.radio === '1'
        delete this.ruleForm.createTime
        let rData = JSON.parse(JSON.stringify(this.ruleForm))
        this.$api.report_fix(rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('提交成功')
          } else { this._status(res.data) }
        })
      } else { this.$message.error('请选择修改的地区') }
    },
    resetForm() {
      for (let key in this.ruleForm) this.ruleForm[key] = ''
    },
    // 获取位置
    areaGet(data) {
      this.$api.getPlace(data.value).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.province = _R; break
            case 1 : this.city = _R; break
            case 2 : this.county = _R; break
            case 3 : this.town = _R; break
            case 4 : this.village = _R; break
            case 5 : this.village = _R; break
          }
        } else { this._status(res.data) }
      })
    },
    remoteMethod(value, num) {
      //清空下级
      switch(num) {
        case 1 : this.areaIds[1] = this.areaIds[2] = this.areaIds[3] = this.areaIds[4] = ''; break
        case 2 : this.areaIds[2] = this.areaIds[3] = this.areaIds[4] = ''; break
        case 3 : this.areaIds[3] = this.areaIds[4] = ''; break
        case 4 : this.areaIds[4] = ''; break
        default : break;
      }
      this.$api.mapSummation({ areaId: value }).then(res => {
        if (res.data.status === 0) {
          if (res.data.data != '') {
            this.ruleForm = JSON.parse(res.data.data)
            this.radio = this.ruleForm.fix ? '1' : '2'
          } else {
            this.radio = '0'
            for (let key in this.ruleForm) this.ruleForm[key] = ''
          }
        } else { this._status(res.data) }
      })
      this.areaGet({ value: { areaId: value }, key: num })
    },
  },
  created() {
    this.areaGet({ value: { areaId: 0 }, key:0 })
  },
}
</script>

<style>
.data_up {padding: 10px 20px;}
h4 {line-height: 48px;padding:  0 10px;margin: 20px 0 10px;border-bottom: 1px solid #eee;}
.center {text-align: center;margin: 20px 0;}
.top-area {display: flex;align-items: center;justify-content: center;margin-bottom: 20px;}
.top-title {
  text-align: right;vertical-align: middle;
  float: left;font-size: 14px;color: #606266;
  line-height: 40px;padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;box-sizing: border-box;
}
</style>